import { FC } from 'react';
import styled from '@xstyled/styled-components';
import { SystemProps } from '@xstyled/system';

export const List: FC<SystemProps> = styled.ulBox`
  list-style: none;
`;
